export default __webpack_public_path__ + "static/media/F13D968E-A6B3-483D-8274-1D979018C22F_1_105_c.506c9a11.jpeg";